// ---------------------------------------------------------------------------
// Global currency. The symbol comes from Settings → Currency and is applied
// everywhere via getCurrency() / money(). Cached in localStorage so it's
// available synchronously on the next load (no flash), set on app load by
// AdminLayout's branding fetch and on save by SettingsPanel.
// ---------------------------------------------------------------------------
const KEY = 'rp_currency';

let CURRENT = '\u20B9'; // ₹
try { const c = localStorage.getItem(KEY); if (c && String(c).trim()) CURRENT = c; } catch (_) {}

export function getCurrency() { return CURRENT; }

export function setCurrency(sym) {
  if (sym && typeof sym === 'string' && sym.trim()) {
    CURRENT = sym;
    try { localStorage.setItem(KEY, sym); } catch (_) {}
  }
}

// money(amount) -> "₹1,234.00" using the chosen symbol and Indian grouping.
// Pass { min, max } to control fraction digits (defaults 2 / 2).
export function money(n, opts) {
  const o = opts || {};
  const min = o.min != null ? o.min : 2;
  const max = o.max != null ? o.max : 2;
  return CURRENT + Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: min, maximumFractionDigits: max });
}
